module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAARCAYAAADQWvz5AAAABHNCSVQICAgIfAhkiAAAAUVJREFUOE+VlIFNAkEURGc6wA7oQEvQDrAC6UA6ACuQErADOtAStAPsgA7GvMs/sh4sxp+QTdjbd/Pnz611pZIsJb1K+pT0aPvYe9y9jSSzAtxJ2kg62ma9WNdAwyEOJ5kXdN5TdRHUqhkPJtlJOvRUnYGS3Et6kvTdHmpUsfdl+9D26CR4sJbEelMtYO5m2kaZv5BEq7eSPvjZfgEEeVV/dKdyyeESgZf7EbSwjYp/VxJUbcfW9pL+BauBvJdfy8HskggMX5jO1ZpChpiMJwqGTJSxdisJNuxsb8eHfo2/+kXVXyD2V62vUxBT66a3UU/7jP1kQ9sa2WCT9VQEcRq+JMRl1ga2BZFo5BI4BgCQoD4UdW37rfZ4FgtYh2pBAJ7rS+f6ADBMsaAEj4PAuRm4Vs5B9SamwKfCRM5i0AAB8ZJTiH8Al42qvG1Ees4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/examinatSystem/collectIcon.png
// module id = 2M72
// module chunks = 3